import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { MARKET_COLUMN, MARKET_VIEW_MODULE } from "../constants/marketViewConstants";

export const setMarketViewPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: MARKET_VIEW_MODULE,
        default_columns: MARKET_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
